module.exports = __webpack_public_path__ + "img/logo_grupo_merca_white.3a7b8106.svg";